import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { TyreStateValueListModel } from '../../models/tyre/tyreStateValue';
import { TyreStateModel, TyreStateListModel } from '../../models/tyre/tyreState';
import { TyrePositionDictionaryListModel } from '../../models/tyre/tyrePosition';
import { SeasonsDictionaryListModel } from '../../models/tyre/seasons';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as BrandsModels from '../../models/tyre/brands';
import * as TyreCarTypesModels from '../../models/tyre/tyreCarTypes';
import * as TyreSegmentsModels from '../../models/tyre/tyreSegments';
import * as TyreParametersModels from '../../models/tyre/tyreParameters';
import * as TyrePreviewModels from '../../models/tyre/tyrePreview';
import * as TyreOfferApiModels from '../../models/tyre/tyreOfferApi';
import { TyreSearchModel } from '../../models/tyre/tyreSearch';
import * as Models from '../../models/commonModels';
import * as TyreParamiterModels from '../../models/tyre/tyreParameters';

@Injectable({
  providedIn: 'root'
})
export class TyreService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getTyreStateValuesDictionary() {
    return this.httpClient.get<TyreStateValueListModel>(`${this.environmentService.getApiURL()}/tyre/tyre-state-values`);
  }

  public getTyrePositionDictionary() {
    return this.httpClient.get<TyrePositionDictionaryListModel>(`${this.environmentService.getApiURL()}/tyre/tyre-positions`);
  }

  public getSeasonsDictionary() {
    return this.httpClient.get<SeasonsDictionaryListModel>(`${this.environmentService.getApiURL()}/tyre/seasons`);
  }

  public getSegmentsDictionary() {
    return this.httpClient.get<TyreSegmentsModels.TyreSegmentsDictionaryListModel>(`${this.environmentService.getApiURL()}/tyre/tyre-segments`);
  }

  public getTyreCarTypesDictionary() {
    return this.httpClient.get<TyreCarTypesModels.TyreCarTypesDictionaryListModel>(`${this.environmentService.getApiURL()}/tyre/tyre-car-types`);
  }

  public getBrandDictionary() {
    return this.httpClient.get<BrandsModels.BrandsDictionaryListModel>(`${this.environmentService.getApiURL()}/tyre/brands`);
  }

  public getTyreParameters() {
    return this.httpClient.get<TyreParametersModels.TyreParametersObjectModel>(`${this.environmentService.getApiURL()}/tyre/tyre-parameters`);
  }

  public getTyreAvailableForSaleParameters() {
    return this.httpClient.get<TyreParametersModels.TyreParametersObjectModel>(`${this.environmentService.getApiURL()}/tyre/tyre-parameters-availabe-for-sale`);
  }

  public getDepositeTyreState(DepositeId: number) {
    return this.httpClient.get<TyreStateListModel>(`${this.environmentService.getApiURL()}/tyre/deposite-tyre-states/${DepositeId}`);
  }

  public setDepositeTyreState(TyreStates: TyreStateModel[]) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<TyreStateModel[]>(`${this.environmentService.getApiURL()}/tyre/set-deposite-tyre-states`, TyreStates, options);
  }

  public getListSold(Search: TyreSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    return this.httpClient.post<TyrePreviewModels.TyrePreviewListModel>(`${this.environmentService.getApiURL()}/tyre/list-sold`, Search, options);
  }

  public getList(Search: TyreSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    return this.httpClient.post<TyrePreviewModels.TyrePreviewListModel>(`${this.environmentService.getApiURL()}/tyre/list`, Search, options);
  }

  public getListReseling(Search: TyreSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    return this.httpClient.post<TyrePreviewModels.TyrePreviewListModel>(`${this.environmentService.getApiURL()}/tyre/list-reseling`, Search, options);
  }

  public getTyreSupplierOffers(Tyre: Models.Request<TyrePreviewModels.TyrePreviewModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreOfferApiModels.TyreSupplierOfferModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-supplier-offers`, Tyre, options);
  }

  public getTyreSupplierOffer(TyreSupplierOffer: Models.Request<TyreOfferApiModels.TyreSupplierOfferModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreOfferApiModels.TyreSupplierOfferModel>>(`${this.environmentService.getApiURL()}/tyre/get-tyre-offer`, TyreSupplierOffer, options);
  }

  public getRimDictionary() {
    return this.httpClient.get<Models.Response<TyrePreviewModels.TyrePreviewModel[]>>(`${this.environmentService.getApiURL()}/tyre/rim-dictionary`);
  }

  public getTyreSuppliers() {
    return this.httpClient.get<Models.ResponseList<TyreOfferApiModels.TyreSupplierModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-suppliers`);
  }

  public getTyreWidthsList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreWidthModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-widths-list`, options);
  }

  public getTyreHeightsList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreHeightModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-heights-list`, options);
  }

  public getTyreDiametersList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreDiameterModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-diameters-list`, options);
  }

  public getTyreConstructionTypesList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreConstructionTypeModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-construction-types-list`, options);
  }

  public getTyreSpeedIndexesList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreSpeedIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-speed-indexes-list`, options);
  }

  public getTyreLoadIndexesList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreLoadIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-load-indexes-list`, options);
  }

  public getTyreReinforcementsList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreReinforcementModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-reinforcements-list`, options);
  }


  public getBrandList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.BrandModel>>(`${this.environmentService.getApiURL()}/tyre/brand-list`, options);
  }

  public getProducerList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.ProducerModel>>(`${this.environmentService.getApiURL()}/tyre/producer-list`, options);
  }

  public getTyreCarTypeList() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<TyreParamiterModels.TyreCarTypesModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-car-types-list`, options);
  }

  public setTyreWidth(Request: Models.Request<TyreParamiterModels.TyreWidthModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreWidthModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-widths-set`, Request, options);
  }

  public setTyreHeight(Request: Models.Request<TyreParamiterModels.TyreHeightModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreHeightModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-heights-set`, Request, options);
  }

  public setTyreDiameter(Request: Models.Request<TyreParamiterModels.TyreDiameterModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreDiameterModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-diameters-set`, Request, options);
  }

  public setTyreConstructionType(Request: Models.Request<TyreParamiterModels.TyreConstructionTypeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreConstructionTypeModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-construction-types-set`, Request, options);
  }

  public setSpeedIndex(Request: Models.Request<TyreParamiterModels.TyreSpeedIndexModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreSpeedIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-speed-indexes-set`, Request, options);
  }

  public setLoadIndex(Request: Models.Request<TyreParamiterModels.TyreLoadIndexModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreLoadIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-load-indexes-set`, Request, options);
  }

  public setReinforcement(Request: Models.Request<TyreParamiterModels.TyreReinforcementModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreReinforcementModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-reinforcements-set`, Request, options);
  }


  public setBrand(Request: Models.Request<TyreParamiterModels.BrandModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.BrandModel>>(`${this.environmentService.getApiURL()}/tyre/brand-set`, Request, options);
  }

  public setProducer(Request: Models.Request<TyreParamiterModels.ProducerModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.ProducerModel>>(`${this.environmentService.getApiURL()}/tyre/producer-set`, Request, options);
  }




  public deleteTyreWidth(Request: Models.Request<TyreParamiterModels.TyreWidthModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreWidthModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-widths-delete`, Request, options);
  }

  public deleteTyreHeight(Request: Models.Request<TyreParamiterModels.TyreHeightModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreHeightModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-heights-delete`, Request, options);
  }

  public deleteTyreDiameter(Request: Models.Request<TyreParamiterModels.TyreDiameterModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreDiameterModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-diameters-delete`, Request, options);
  }

  public deleteTyreConstructionType(Request: Models.Request<TyreParamiterModels.TyreConstructionTypeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreConstructionTypeModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-construction-types-delete`, Request, options);
  }

  public deleteSpeedIndex(Request: Models.Request<TyreParamiterModels.TyreSpeedIndexModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreSpeedIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-speed-indexes-delete`, Request, options);
  }

  public deleteLoadIndex(Request: Models.Request<TyreParamiterModels.TyreLoadIndexModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreLoadIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-load-indexes-delete`, Request, options);
  }

  public deleteReinforcement(Request: Models.Request<TyreParamiterModels.TyreReinforcementModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreReinforcementModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-reinforcements-delete`, Request, options);
  }



  public mergeTyreWidth(Request: Models.ContextRequest<TyreParamiterModels.TyreWidthModel, TyreParamiterModels.TyreWidthModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreParamiterModels.TyreWidthModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-widths-merge`, Request, options);
  }

  public mergeTyreHeight(Request: Models.ContextRequest<TyreParamiterModels.TyreHeightModel, TyreParamiterModels.TyreHeightModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreParamiterModels.TyreHeightModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-heights-merge`, Request, options);
  }

  public mergeTyreDiameter(Request: Models.ContextRequest<TyreParamiterModels.TyreDiameterModel, TyreParamiterModels.TyreDiameterModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreParamiterModels.TyreDiameterModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-diameters-merge`, Request, options);
  }

  public mergeTyreConstructionType(Request: Models.ContextRequest<TyreParamiterModels.TyreConstructionTypeModel, TyreParamiterModels.TyreConstructionTypeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreParamiterModels.TyreConstructionTypeModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-construction-types-merge`, Request, options);
  }

  public mergeSpeedIndex(Request: Models.ContextRequest<TyreParamiterModels.TyreSpeedIndexModel, TyreParamiterModels.TyreSpeedIndexModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreParamiterModels.TyreSpeedIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-speed-indexes-merge`, Request, options);
  }

  public mergeLoadIndex(Request: Models.ContextRequest<TyreParamiterModels.TyreLoadIndexModel, TyreParamiterModels.TyreLoadIndexModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreParamiterModels.TyreLoadIndexModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-load-indexes-merge`, Request, options);
  }

  public mergeReinforcement(Request: Models.ContextRequest<TyreParamiterModels.TyreReinforcementModel, TyreParamiterModels.TyreReinforcementModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<TyreParamiterModels.TyreReinforcementModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-reinforcements-merge`, Request, options);
  }


  public updateTyreDiameter(Request: Models.Request<TyreParamiterModels.TyreDiameterModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreDiameterModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-diameters-update`, Request, options);
  }

  public updateTyreCarType(Request: Models.Request<TyreParamiterModels.TyreCarTypesModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<TyreParamiterModels.TyreCarTypesModel>>(`${this.environmentService.getApiURL()}/tyre/tyre-car-types-update`, Request, options);
  }
}
